import AbstractComponent from './AbstractComponent';

class Scrollbar extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleScrollRef = this.handleScrollRef.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$track = ui.$element.querySelector('div');
    ui.$ref = document.body.querySelector(`#${ui.$element.dataset.ref}`);
    return ui;
  }

  events(listen) {
    super.events(listen);
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    this.ui.$ref[listener]('scroll', this.handleScrollRef);
  }

  handleResize(event) {
    const { $ref, $track } = this.ui;
    $track.style.width = `${($ref.offsetWidth / $ref.scrollWidth) * 100}%`;
  }

  handleScrollRef(event) {
    const { $ref, $track } = this.ui;
    $track.style.left = `${($ref.scrollLeft / $ref.scrollWidth) * 100}%`;
  }
}

export default Scrollbar;
